import React from 'react';
import { FC } from 'react';
import { IconProps } from '../types';

export const EmploymentIncomeIcon: FC<IconProps> = ({ width = '24', height = '24', className }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 22 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M14.75 18.75V2.75C14.75 2.21957 14.5393 1.71086 14.1642 1.33579C13.7891 0.960714 13.2804 0.75 12.75 0.75H8.75C8.21957 0.75 7.71086 0.960714 7.33579 1.33579C6.96071 1.71086 6.75 2.21957 6.75 2.75V18.75M2.75 4.75H18.75C19.8546 4.75 20.75 5.64543 20.75 6.75V16.75C20.75 17.8546 19.8546 18.75 18.75 18.75H2.75C1.64543 18.75 0.75 17.8546 0.75 16.75V6.75C0.75 5.64543 1.64543 4.75 2.75 4.75Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
